const Error = () => {
  return (
    <div>
      <h1>
        ERROR 404 <hr />
        Page Not Found{' '}
      </h1>
    </div>
  );
};

export default Error;
